import React from "react";
import { Routes, Route } from "react-router-dom";
import NewAccount from "./new-account";
import AccountsList from "./accounts-list";

//
const Accounts = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<AccountsList />} />
         <Route path="/" element={<AccountsList />} />
         <Route path="/new" element={<NewAccount />} />
      </Routes>
    </React.Fragment>
  );
};

export default Accounts;
